var map = {
	"./attraversamento-pedonale-so.png": 6429,
	"./attraversamento-pedonale.png": 4804,
	"./dare-precedenza-so.png": 9630,
	"./dare-precedenza.png": 6269,
	"./diritto-precedenza-senso-unico-alternato.png": 1803,
	"./divieto-accesso.png": 3819,
	"./divieto-sorpasso-auto.png": 5612,
	"./divieto-sorpasso-autocarri.png": 5011,
	"./divieto-sosta-fermata.png": 3177,
	"./divieto-sosta.png": 3598,
	"./divieto-transito-autocarri.png": 4677,
	"./divieto-transito-limite-altezza.png": 7953,
	"./divieto-transito-limite-larghezza.png": 4204,
	"./divieto-transito-limite-peso.png": 8163,
	"./divieto-transito.png": 6236,
	"./dosso-so.png": 4290,
	"./fermata-bus-so.png": 3937,
	"./lanterna-semaforica.png": 1899,
	"./limite-vel-20.png": 7098,
	"./limite-vel-30.png": 1637,
	"./limite-vel-40.png": 524,
	"./limite-vel-50.png": 4231,
	"./limite-vel-60.png": 678,
	"./limite-vel-70.png": 5521,
	"./limite-vel-80.png": 5640,
	"./obbligo-dare-precedenza-senso-unico-alternato.png": 129,
	"./obbligo-direzione-diritto-dx.png": 1074,
	"./obbligo-direzione-diritto-sx.png": 5807,
	"./obbligo-direzione-diritto.png": 3843,
	"./obbligo-direzione-dx-sx.png": 3766,
	"./obbligo-direzione-dx.png": 2888,
	"./obbligo-direzione-sx.png": 1401,
	"./obbligo-passaggio-dx-sx.png": 4551,
	"./obbligo-passaggio-dx.png": 5643,
	"./obbligo-passaggio-sx.png": 8486,
	"./parcheggio-disabili-so.png": 6787,
	"./parcheggio-merci-so.png": 2818,
	"./parcheggio.png": 5318,
	"./passo-carrabile.png": 2639,
	"./pericolo-attraversamento-pedonale.png": 544,
	"./pericolo-doppia-curva-dx.png": 7869,
	"./pericolo-doppia-curva-sx.png": 356,
	"./pericolo-doppio-senso.png": 8313,
	"./pericolo-dosso_cunetta_strada-dissestata.png": 9266,
	"./pericolo-intersezione-con-precedenza-dx-sx.png": 7060,
	"./pericolo-intersezione-con-precedenza-dx.png": 7206,
	"./pericolo-intersezione-con-precedenza-sx.png": 1211,
	"./pericolo-lanterna-semaforica.png": 6687,
	"./pericolo-lavori-in-corso.png": 5261,
	"./pericolo-strada-sdrucciolevole.png": 644,
	"./pericolo-strettoia-dx-sx.png": 1677,
	"./pericolo-strettoia-dx.png": 169,
	"./pericolo-strettoia-sx.png": 1656,
	"./pericolo.png": 9414,
	"./rotatoria.png": 348,
	"./senso-unico-dx.png": 1213,
	"./senso-unico-sx.png": 52,
	"./stop-so.png": 2974,
	"./stop.png": 2429,
	"./strada-senza-sbocco.png": 1480
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2444;